module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"FinLexiconOverlay":{"lexicon_title":"finLexikon"}},"en":{"FinLexiconOverlay":{"lexicon_title":"finDictionary"}}}')
  delete Component.options._Ctor
}
